import { ShowPostScreen, ShowPostScreenProps } from 'shared/screens/blog/show-post';
import { withServerProps } from '@web/library/with-server-props';
import { Page } from '@web/components/page';
import type { GetServerSideProps } from 'next';
import { injectAdTagAfterHeadings } from 'shared/library/inject-ad-tag-after-headings';
import { staticImageUrl } from 'shared/library/static-images';

const defaultOgImage = staticImageUrl('open-graph');

function parsePostDate(value: string | null | undefined, fallback: Date) {
  if (!value) return fallback;

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? fallback : date;
}

export default function ShowPost(props: ShowPostScreenProps) {
  const publishedAt = parsePostDate(props.post.published_at, new Date(0));
  const updatedAt = parsePostDate(props.post.updated_at, publishedAt);

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.forArticle(
          props.post.title,
          props.post.summary,
          props.post.avatar?.url ?? defaultOgImage,
          publishedAt,
          updatedAt,
        )
      }
    >
      <ShowPostScreen {...props} />
    </Page>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const result = await withServerProps(ShowPostScreen.pageBuilder)(context);
  if (!('props' in result)) return result;

  const props = await result.props;
  // Compile for both initial requests and Next data navigation, without shipping the parser.
  const { compileMarkdown } = await import('shared/library/compile-markdown.server');

  return {
    props: {
      ...props,
      compiledPostMarkdown: compileMarkdown(injectAdTagAfterHeadings(props.post.body)),
    },
  };
};
